import React, { ChangeEvent, MouseEvent, useRef } from 'react'
import * as styles from './actions.module.scss'
import {
   AddWithAIToggleProps,
   UploadButtonProps,
} from './importItemsModal.type'
import { Toggle, ToggleInfo } from '../form/fields'
import { BsCloudArrowUp as ImportIcon } from 'react-icons/bs'
import Svg from '../svg/svg'

export const DownloadButton = () => (
   <a
      href="/ItemsImportTemplate.csv"
      download="ItemsImportTemplate"
      className={styles.linkButton}
   >
      <Svg
         id="download"
         width="20"
         height="20"
         overrideViewBox="0 0 8 8"
         fill="#003e64"
      />
      <span>Download Template</span>
   </a>
)

export const UploadButton = ({
   selectedFile,
   setSelectedFile,
}: UploadButtonProps) => {
   const fileInputRef = useRef(null)

   const handleButtonClick = (e: MouseEvent<HTMLButtonElement>) => {
      e.preventDefault()
      fileInputRef.current.click()
   }

   const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
      const file = event.target.files[0]
      setSelectedFile(file)
   }
   return (
      <div className={styles.uploadButtonWrapper}>
         <input
            ref={fileInputRef}
            type="file"
            onChange={handleFileChange}
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            multiple={false}
            className={styles.hiddenFileInput}
         />
         <button
            onClick={handleButtonClick}
            type="button"
            className={styles.uploadButton}
         >
            <ImportIcon size={20} />
            <span>Select File</span>
         </button>
         {selectedFile && <span>{selectedFile.name}</span>}
      </div>
   )
}

export const AddWithAIToggle = ({
   addImagesWithAI,
   setAddImagesWithAI,
}: AddWithAIToggleProps) => {
   const handleToggle = () => {
      setAddImagesWithAI(!addImagesWithAI)
   }

   return (
      <div className={styles.toggleWrapper}>
         <Toggle
            id="add-with-ai"
            size="md"
            isChecked={addImagesWithAI}
            onToggle={handleToggle}
         />
         <ToggleInfo name="Add Images with AI" value={addImagesWithAI} />
      </div>
   )
}

export const HelpButton = () => (
   <a
      href="https://help.sharemytoolbox.com/knowledge/item-import-and-export"
      target="_blank"
      className={styles.helpButton}
   >
      <Svg id="help" fill="#2A4E8D" stroke="#2A4E8D" width={17} height={17} />{' '}
      <span>Get Help</span>
   </a>
)
